// extracted by mini-css-extract-plugin
module.exports = {"backLink":"style_backLink__XOU6k","withGap":"style_withGap__WH4L0"};